import { useState } from 'react';
import { articles } from '@/mocks/articles';

export default function ReviewSection() {
  const topArticle = articles[6];
  const [commentIndex, setCommentIndex] = useState(0);
  const comments = topArticle.comments || [];

  const handlePrev = () => {
    setCommentIndex((prev) => (prev === 0 ? comments.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCommentIndex((prev) => (prev === comments.length - 1 ? 0 : prev + 1));
  };

  const currentComment = comments[commentIndex];

  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-center text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-12">
            （全网神评）
          </h2>

          {currentComment && (
            <div className="relative">
              <div className="flex items-center gap-3 mb-6">
                <span className="px-4 py-1.5 rounded-full bg-foreground-950 text-background-50 text-sm font-label whitespace-nowrap flex items-center gap-1.5">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <span>{topArticle.rating}</span>
                </span>
                <span className="text-sm text-foreground-500">来自文章《{topArticle.title.slice(0, 15)}...》</span>
              </div>

              <blockquote className="text-lg md:text-xl font-heading text-foreground-800 leading-relaxed mb-8">
                &ldquo;{currentComment.content}&rdquo;
              </blockquote>

              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={currentComment.avatar}
                    alt={currentComment.user}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-label font-semibold text-foreground-950">{currentComment.user}</p>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {Array.from({ length: currentComment.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-xs text-accent-500"></i>
                    ))}
                  </div>
                </div>
              </div>

              <div className="flex gap-2 absolute bottom-0 right-0">
                <button
                  onClick={handlePrev}
                  className="w-10 h-10 flex items-center justify-center rounded-md border border-foreground-200 text-foreground-600 hover:bg-background-50 transition-colors cursor-pointer"
                  aria-label="上一条评论"
                >
                  <i className="ri-arrow-left-s-line"></i>
                </button>
                <button
                  onClick={handleNext}
                  className="w-10 h-10 flex items-center justify-center rounded-md bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
                  aria-label="下一条评论"
                >
                  <i className="ri-arrow-right-s-line"></i>
                </button>
              </div>
            </div>
          )}

          <div className="flex items-center justify-center gap-1.5 mt-10">
            {comments.map((_, i) => (
              <button
                key={i}
                onClick={() => setCommentIndex(i)}
                className={`w-2 h-2 rounded-full transition-colors cursor-pointer ${
                  i === commentIndex ? 'bg-foreground-950' : 'bg-foreground-300'
                }`}
                aria-label={`第${i + 1}条评论`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}